module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAwCAYAAACynDzrAAAA7UlEQVRoQ+3YvQrCMABF4ST+FLROgnRScfENBJ/bZwiOgrMaEOkggrMIqQ9gaoTrJKd7Ohy+3CF2OZsem/h0hu+tgOv1a7uoJsGaZk6fRIFO1xPokwwCZe4NgQikTSuCEIQgrQCCtH5sEIIQpBVAkNaPDUKQLmi/XoXSWZ47Eimv0XhLoHZkBMpcQAIRSNtoBCEIQVoBBGn92CAEIUgrgCCtHxuEIARpBb4RdN+5MBpG3oMSsepb4S2B2hkRKHPFCEQgbcMRhCAEaQUQpPVjgxCEIK0AgrR+bBCCfiDosi021fhRar/6z9OH8+D0Ahdx6qz6Of0QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/ico/german.png
// module id = giCP
// module chunks = 0